import { Component, OnInit } from '@angular/core';
import { UserService } from '../user.service';
import { MatDialog } from '@angular/material/dialog';
import { UserProfileDialogComponent } from '../user/profile/userprofile.component';
import { UpdatePasswordDialogComponent } from '../user/profile/update-password.component';
import { Router } from '@angular/router';
@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit {
  isExpanded = false;
  currentPageIsCalculator = false;
  currentPageIsAbout = false;
  isLoggedIn = false;
  currentUrl = window.location.href;
  isAdmin = false;

  async checkCurrentPage() {

    if (this.currentUrl.toString().toLowerCase().includes("about")) {
      this.currentPageIsAbout = true;
      this.currentPageIsCalculator = false;
    }
    else {
      this.currentPageIsCalculator = true;
      this.currentPageIsAbout = false;
    }
  }

  async checkIfAdmin() {
    if (this.userService.roleMatch(['Admin'])) {
      this.isAdmin = true;
    }
  }
  async checkifLoggedIn() {
    if (localStorage.getItem('token') != null) {
      this.isLoggedIn = true;
    }
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
  userFullName = '';
  showConfiguration: boolean = true;
  constructor(private userService: UserService, public dialog: MatDialog, private router: Router) {
    this.userFullName = localStorage.getItem('email');
  }

  async ngOnInit(): Promise<void> {
    this.checkIfAdmin();
    this.showConfiguration = this.userService.roleMatch(['Admin']);
    this.checkifLoggedIn()
    this.checkCurrentPage();
  }

  async updateUserProfile(): Promise<void> {
    await this.userService.getUserProfile().then(user => {
      const dialogRef = this.dialog.open(UserProfileDialogComponent, {
        width: '550px',
        data: {
          dialogTitle: 'Update Profile',
          dialogMode: 'update',
          user: user
        }
      });

      dialogRef.afterClosed().subscribe(result => {

      });
    }
    );
  }

  async updateUserPassword(): Promise<void> {
    const dialogRef = this.dialog.open(UpdatePasswordDialogComponent, {
      width: '550px',
      data: {
        dialogTitle: 'Update Password',
        dialogMode: 'update',
      }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }
  logout() {
    this.userService.logout().subscribe(res => {
      localStorage.removeItem('token');
      localStorage.removeItem('email');
      this.router.navigateByUrl('/login');
    });
  }
}
